<template>
  <v-card :disabled="loading" :loading="loading">
    <v-card-title>
      <h2>{{ $t("officer_config.config_curriculum_constraint") }}</h2>
    </v-card-title>
    <v-card-text>
      <v-tabs v-model="level_tab">
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab v-for="(level, i) in levels" :key="i">
          <h3>{{ objectTranslator(level, "LEVEL_NAME") }}</h3>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="level_tab" touchless>
        <v-tab-item v-for="(level, i) in levels" :key="i">
          <v-card flat>
            <v-card-text>
              <v-autocomplete
                v-model="year_id[level.LEVEL_ID]"
                v-bind:label="$t('officer_config.academic_year')"
                v-bind:items="
                  listFilter(config_years, level.LEVEL_ID, 'LEVEL_ID')
                "
                v-bind:item-value="(item) => item.YEAR_ID"
                v-bind:item-text="(item) => item.SEMESTER + ' / ' + item.YEAR"
                outlined
                @change="(year_id) => select_year(level.LEVEL_ID, year_id)"
              ></v-autocomplete>

              <div v-show="year_id && year_id[level.LEVEL_ID]">
                <v-divider></v-divider>

                <v-autocomplete
                  v-model="round_id[level.LEVEL_ID]"
                  v-bind:label="$t('officer_config.round_number_name')"
                  v-bind:items="rounds_for_show(rounds[level.LEVEL_ID])"
                  v-bind:item-value="(item) => item.ROUND_ID"
                  v-bind:item-text="
                    (item) =>
                      item.ROUND_NUMBER + ' - ' + objectTranslator(item, 'NAME')
                  "
                  outlined
                  @change="
                    (round_id) =>
                      select_round(
                        level.LEVEL_ID,
                        year_id[level.LEVEL_ID],
                        round_id
                      )
                  "
                ></v-autocomplete>

                <v-autocomplete
                  v-model="project_id[level.LEVEL_ID]"
                  v-bind:label="$t('officer_config.project_name')"
                  v-bind:items="projects_for_show(projects, level.LEVEL_ID)"
                  v-bind:item-value="(item) => item.PROJECT_ID"
                  v-bind:item-text="
                    (item) => objectTranslator(item, 'PROJECT_NAME')
                  "
                  outlined
                  @change="
                    (project_id) => select_project(level.LEVEL_ID, project_id)
                  "
                ></v-autocomplete>

                <!-- <h1><span class="deep-orange--text">{{$t('officer_config.round_number_name')}} </span>:</h1> -->

                <div
                  v-show="project_id && project_id[level.LEVEL_ID]"
                  v-for="round_item in listFilter(
                    rounds[level.LEVEL_ID],
                    round_id[level.LEVEL_ID],
                    'ROUND_ID'
                  )"
                  :key="round_item.ROUND_ID"
                >
                  <v-divider class="mb-5"></v-divider>
                  <h1>
                    <span class="blue--text"
                      >{{ $t("officer_config.round") }} </span
                    >: {{ round_item.ROUND_NUMBER }} -
                    {{ objectTranslator(round_item, "NAME") }}
                  </h1>

                  <div
                    class="mt-5 mb-5 ml-5"
                    v-for="(project_item, project_index) in listFilter(
                      projects[level.LEVEL_ID],
                      project_id[level.LEVEL_ID],
                      'PROJECT_ID'
                    )"
                    :key="project_item.PROJECT_ID"
                  >
                    <h2>
                      <span class="blue--text text--darken-2">
                        {{ (project_index + 1).toString() }}.
                        {{ $t("officer_config.project_name") }}
                        {{ objectTranslator(project_item, "PROJECT_NAME") }}
                      </span>
                    </h2>
                    <br />
                    <span class="green accent-1 font-weight-bold">
                      {{ $t("officer_config.application_fee") }} :</span
                    >
                    {{ formatNumber(project_item.APPLICATION_FEE) }} <br />
                    <span class="yellow accent-2 font-weight-bold"
                      >{{ $t("officer_config.application_date") }} :</span
                    >
                    {{
                      dateFromDBTranslatorFull(
                        project_item.START_APPLICATION_DATE
                      )
                    }}
                    -
                    {{
                      dateFromDBTranslatorFull(
                        project_item.END_APPLICATION_DATE
                      )
                    }}
                    <br />
                    <span class="pink lighten-4 font-weight-bold">
                      {{ $t("officer_config.application_pay") }} :</span
                    >
                    {{
                      dateFromDBTranslatorFull(
                        project_item.START_APPLICATION_PAY_DATE
                      )
                    }}
                    -
                    {{
                      dateFromDBTranslatorFull(
                        project_item.END_APPLICATION_PAY_DATE
                      )
                    }}
                    <div
                      class="mt-5 ml-5"
                      v-for="(faculty_item,
                      faculty_index) in available_faculties(
                        curriculums[level.LEVEL_ID],
                        project_item.PROJECT_ID
                      )"
                      :key="faculty_item.MASTER_REG_FACULTY_ID"
                    >
                      <h3>
                        <span class="indigo--text text--darken-3">
                          {{ (project_index + 1).toString() }}.{{
                            (faculty_index + 1).toString()
                          }}
                          )
                          {{ $t("officer_config.faculty") }}
                          {{ objectTranslator(faculty_item, "FACULTY_NAME") }}
                        </span>
                      </h3>

                      <v-row>
                        <v-col
                          cols="12"
                          lg="6"
                          xl="4"
                          v-for="curr_item in filtered_curriculums(
                            curriculums[level.LEVEL_ID],
                            project_item.PROJECT_ID,
                            faculty_item.MASTER_REG_FACULTY_ID
                          )"
                          :key="curr_item.CURRICULUM_ID"
                        >
                          <v-card>
                            <v-card-text>
                              <h3 class="font-weight-black deep-orange--text">
                                {{ $t("officer_config.curriculum") }} :
                                <span v-if="curr_item.LEVEL_ID == '1'">
                                  {{
                                    objectTranslator(
                                      curr_item,
                                      "CURRICULUM_SHORT_NAME_TH"
                                    )
                                  }}
                                </span>
                                <span v-else>
                                  {{
                                    objectTranslator(
                                      curr_item,
                                      "CURRICULUM_FULL_NAME_TH"
                                    )
                                  }}
                                </span>
                              </h3>
                              <h4
                                v-if="curr_item.BRANCH_NAME_TH"
                                class="font-weight-black brown--text"
                              >
                                {{ $t("officer_config.branch") }} :
                                {{ objectTranslator(curr_item, "BRANCH_NAME") }}
                              </h4>
                              <br />
                              <div
                                v-for="constraint_item in listFilter(
                                  curriculumConstraints[level.LEVEL_ID],
                                  curr_item.CURRICULUM_ID,
                                  'CURRICULUM_ID'
                                )"
                                :key="constraint_item.CONSTRIANT_ID"
                              >
                                <span class="font-weight-black">
                                  {{
                                    objectTranslator(
                                      constraint_item,
                                      "CONSTRAINT_DESCRIPTION"
                                    )
                                  }}
                                  :
                                </span>
                                <span
                                  class="font-weight-black deep-orange--text"
                                >
                                  {{ constraint_item.VALUE }}
                                </span>
                              </div>
                              <br />
                              <v-divider color="white"></v-divider>
                              <span class="cyan lighten-4 font-weight-bold">
                                {{ $t("officer_config.tuition_fee") }} :</span
                              >
                              {{ formatNumber(curr_item.CURRICULUM_FEE) }}
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <span
                                v-show="
                                  current_display_mode === display_modes.NORMAL
                                "
                              >
                                <v-btn
                                  color="blue"
                                  outlined
                                  class="ml-2"
                                  @click="
                                    copyConstraints(curr_item.CURRICULUM_ID)
                                  "
                                  >{{ $t("officer_config.copy") }}
                                </v-btn>

                                <v-btn
                                  color="orange"
                                  outlined
                                  class="ml-2"
                                  @click="
                                    $refs.addEditDialog.open_edit_modal({
                                      item: curr_item,
                                    })
                                  "
                                  >{{ $t("officer_config.edit") }}
                                </v-btn>
                              </span>

                              <span
                                v-show="
                                  copying_curriculum_id ===
                                    curr_item.CURRICULUM_ID
                                "
                              >
                                <v-btn
                                  color="purple"
                                  outlined
                                  class="ml-2"
                                  @click="finish()"
                                  >{{ $t("officer_config.finish") }}
                                </v-btn>
                              </span>

                              <span
                                v-show="
                                  copying_curriculum_id !==
                                    curr_item.CURRICULUM_ID &&
                                    current_display_mode ===
                                      display_modes.COPYING
                                "
                              >
                                <v-btn
                                  color="teal"
                                  outlined
                                  class="ml-2"
                                  @click="
                                    paste(
                                      curr_item.CURRICULUM_ID,
                                      level.LEVEL_ID,
                                      year_id[level.LEVEL_ID]
                                    )
                                  "
                                  >{{ $t("officer_config.paste") }}
                                </v-btn>
                              </span>
                            </v-card-actions>
                          </v-card>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>

    <ConfigCurriculumConstraintAddEditDialog
      ref="addEditDialog"
      :toggle_loading="toggle_loading"
      :fetch_data="fetch_data"
    />
  </v-card>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import ConfigCurriculumConstraintAddEditDialog from "@/components/config/ConfigCurriculumConstraintAddEditDialog";
import {
  objectTranslator,
  dateFromDBTranslatorFull,
  dateFromDBTranslator as dt,
  formatNumber,
} from "@/helper/translator";
import { listFilter, getById } from "@/helper/filter";
import ConfigProvider from "@/services/config.provider";
import GenericProvider from "@/services/generic.provider";
import { uniq_by_prop } from "@/helper/array";

const configService = new ConfigProvider();
const genericService = new GenericProvider();
const { mapFields: mapOfficerConfigFields } = createHelpers({
  getterType: "officerConfig/getField",
  mutationType: "officerConfig/updateField",
});

export default {
  name: "ConfigAdmissionCurriculum",
  data: function() {
    return {
      loading: false,
      level_tab: null,

      //--- selected data in each level panel
      rounds: {}, // each for level id
      projects: {}, // each for level id
      curriculums: {}, // each for level id
      curriculumConstraints: {}, // each for level id
      year_id: {}, // each for level id
      round_id: {}, // each for level id
      project_id: {}, // each for level id

      display_modes: {
        NORMAL: 1,
        COPYING: 2,
      },
      current_display_mode: 1,
      copying_curriculum_id: null,
    };
  },
  components: {
    ConfigCurriculumConstraintAddEditDialog,
  },
  computed: {
    levels() {
      return this.$store.state.ref.levels;
    },
    ...mapOfficerConfigFields({
      config_years: "config_years",
    }),
  },
  methods: {
    dt,
    getById,
    listFilter,
    objectTranslator,
    dateFromDBTranslatorFull,
    formatNumber,

    copyConstraints(id) {
      this.current_display_mode = this.display_modes.COPYING;
      this.copying_curriculum_id = id;
    },
    async paste(id, level_id, year_id) {
      this.loading = true;
      await genericService.copyCurriculumConstraints({
        from_CURRICULUM_ID: this.copying_curriculum_id,
        to_CURRICULUM_ID: id,
      });
      await this.fetch_data(level_id, year_id);
      this.loading = false;
    },
    finish() {
      this.current_display_mode = this.display_modes.NORMAL;
      this.copying_curriculum_id = null;
    },

    toggle_loading(status) {
      this.loading = status;
    },

    available_faculties(curriculums, project_id) {
      const cur_in_project = this.listFilter(
        curriculums,
        project_id,
        "PROJECT_ID"
      );
      const uniqueById = uniq_by_prop("MASTER_REG_FACULTY_ID");
      const ret = uniqueById(cur_in_project);
      return ret.map((item) => ({
        MASTER_REG_FACULTY_ID: item.MASTER_REG_FACULTY_ID,
        MASTER_REG_CURRICULUM_ID: item.MASTER_REG_CURRICULUM_ID,
        FACULTY_NAME_TH: item.FACULTY_NAME_TH,
        FACULTY_NAME_EN: item.FACULTY_NAME_EN,
      }));
    },

    filtered_curriculums(curriculums, project_id, faculty_id) {
      const ret = this.listFilter(curriculums, project_id, "PROJECT_ID");
      const ret2 = this.listFilter(ret, faculty_id, "MASTER_REG_FACULTY_ID");
      return ret2;
    },

    rounds_for_show(rounds_in_level) {
      if (rounds_in_level) {
        return [
          ...rounds_in_level,
          {
            NAME_EN: "All",
            NAME_TH: "ทั้งหมด",
            ROUND_ID: "all",
            ROUND_NUMBER: "",
          },
        ];
      } else return [];
    },

    projects_for_show(projects, level_id) {
      if (projects[level_id]) {
        if (this.round_id[level_id] !== "all") {
          return projects[level_id].filter(
            (item) => item.ROUND_ID === this.round_id[level_id]
          );
        }
        return [
          ...projects[level_id],
          {
            PROJECT_NAME_EN: "All",
            PROJECT_NAME_TH: "ทั้งหมด",
            PROJECT_ID: "all",
          },
        ];
      } else return [];
    },

    async fetch_ref_data(level_id, year_id) {
      // non editable data of this page
      this.loading = true;
      const rounds = await configService.getFilteredRounds({ year_id });
      this.$set(this.rounds, level_id, rounds);
      const projects = await configService.getFilteredProjects({ year_id });
      this.$set(this.projects, level_id, projects);
      this.loading = false;
    },

    async fetch_data(level_id, year_id) {
      // editable data of this page
      this.loading = true;
      const curriculums = await configService.getFilteredCurriculums({
        year_id,
      });
      this.$set(this.curriculums, level_id, curriculums);
      const curriculumConstraints = await configService.getFilteredCurriculumConstraints(
        {
          year_id,
        }
      );
      this.$set(this.curriculumConstraints, level_id, curriculumConstraints);
      this.loading = false;
    },

    async select_year(level_id, year_id) {
      this.round_id[level_id] = null;
      this.project_id[level_id] = null;
      await this.fetch_ref_data(level_id, year_id);
    },

    async select_round(level_id, year_id, round_id) {
      this.project_id[level_id] = null;
      this.round_id[level_id] = round_id;
      await this.fetch_ref_data(level_id, year_id);
    },

    async select_project(level_id, project_id) {
      this.project_id[level_id] = project_id;
      await this.fetch_data(level_id, this.year_id[level_id]);
    },
  },
  created: function() {
    this.$store.dispatch("ref/getLevels");
    this.$store.dispatch("officerConfig/getYears");
  },
};
</script>

<style scoped>
th {
  background-color: #546e7a !important;
  overflow: hidden;
  white-space: nowrap;
  border-width: 1px;
  border-right-width: 0;
  border-style: solid;
  border-color: rgb(17, 22, 41);
}
td {
  overflow: hidden;
  white-space: nowrap;
  border-width: 1px;
  border-right-width: 0;
  border-style: solid;
  border-color: rgb(211, 211, 211);
}
</style>
